/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";

import io from "socket.io-client";

import { USER_CONNECTED, LOGOUT, VERIFY_USER } from "../../Events";
import LoginForm from "./LoginForm";
import ChatContainer from "./ChatContainer";

import ChatHead from "../../containers/live/ChatHead";

import LiveInfo from "../../containers/content/LiveInfo";

import axios from "axios";
import parse from "html-react-parser";
import { toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
//const socketUrl = "http://58.226.94.199:3231"
const socketUrl = "https://api.aniplustv.com:3232";

class Layout extends Component {
  state = {
    socket: null,
    user: null,
    connect: "N",
    existLive: true,
  };
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.subTitle !== nextProps.childProps.subTitle;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    if (this.props.childProps.subTitle !== nextProps.childProps.subTitle) {
    }
  };
  componentWillMount = () => {
    this._isMounted = true;
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === "") {
      //history.push('/login')
    } else {
      if (this._isMounted) {
        this.initSocket();
      }
    }
  };

  initSocket = () => {
    const socket = io(socketUrl);
    socket.on("connect", () => {
      if (this.state.user) {
        this.reconnect(socket);
      } else {
        //console.log('client connect.')
      }
    });

    this.setState({
      socket,
    });
  };
  reconnect = (socket) => {
    socket.emit(
      VERIFY_USER,
      this.state.user.name,
      this.state.user.icon,
      ({ isUser, user }) => {
        if (isUser) {
          this.setState({ user: null });
        } else {
          this.setUser(user);
        }
      }
    );
  };

  _getConnect = () => {
    this.setState({
      connect: "Y",
    });
  };

  setUser = (user) => {
    const { socket } = this.state;
    socket.emit(USER_CONNECTED, user);
    this.setState({
      user,
    });
  };
  logout = () => {
    const { socket, connect } = this.state;
    if (connect === "Y") {
    } else {
      socket.emit(LOGOUT);
      this.setState({
        user: null,
      });
    }
  };
  _getNicname = async () => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === "") {
      //alert('로그인 후 이용할 수 있습니다.')
      toast.warn("로그인 후 이용이 가능합니다.");
    } else {
      const result = await this._getNicnameApi();
      const intReturn = result.data[0].intReturn;
      const infoData = result.data[0].listData;
      //console.log(infoData)

      if (intReturn === 0) {
        this.setState({
          nicname: infoData[0].nicName,
          icon: infoData[0].icon,
        });
      }
    }
  };
  _getNicnameApi = () => {
    const { apiUrl, loginId } = this.props;
    //console.log(apiUrl + '/nicnameIcon?userid=' + loginId)
    return axios(apiUrl + "/nicnameIcon?userid=" + loginId)
      .then((response) => response)
      .catch((error) => {
        //console.log('get info error')
      });
  };
  handleSubmit = (e) => {
    //e.preventDefault()
    const { socket, nicname, icon } = this.state;

    socket.emit(VERIFY_USER, nicname, icon, this.setUser);
    //console.log('소켓 전송...')
  };
  _existLive = (val) => {
    this.setState({
      existLive: val,
    });
  };
  _onItem = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  render() {
    const { socket, user, connect, existLive } = this.state;
    const {
      img,
      title,
      subTitle,
      contentSysnopsis,
      intReturn,
      chatOn,
      onChatChange,
      contentSerial,
    } = this.props.childProps;
    const { loginId } = this.props;

    //console.log(connect)
    return (
      <Fragment>
        <ChatHead
          intReturn={intReturn}
          chatOn={chatOn}
          onChatChange={onChatChange}
          logout={this.logout}
          connect={connect}
        />
        <div className="list_top" style={existLive ? null : { height: 140 }}>
          <dl>
            <dt>
              <img src={img} />
            </dt>
            <dd
              style={{ paddingBottom: 20, cursor: "pointer" }}
              onClick={() => this._onItem(contentSerial)}
            >
              <h2>{title}</h2>
              <h3>{subTitle}</h3>
              <p>
                {contentSysnopsis
                  ? parse(
                      contentSysnopsis.length > 40
                        ? contentSysnopsis.substr(0, 40) + "..."
                        : contentSysnopsis.replace(/<[^>]+>/g, "")
                    )
                  : null}
              </p>
            </dd>
            {existLive ? (
              <table className="livetable01" style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "20%", textAlign: "center" }}>
                      <span className="bon">LIVE</span>
                      <br />
                      <span className="jae">방영정보</span>
                    </td>
                    <td>
                      {contentSerial === null ||
                      contentSerial === undefined ? null : (
                        <LiveInfo
                          contentSerial={parseInt(contentSerial)}
                          subTitle={subTitle}
                          existLive={this._existLive}
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : null}
          </dl>
        </div>

        <div className="live_chatting">
          {loginId === "" || loginId === null || loginId === undefined ? (
            <Fragment>
              <div className="chatting_position">
                <div className="chatting_group"></div>
              </div>
              {/*
                            <div className="chatting_icon">
                                <div className="div_ul">
                                    <div className="div_li"><img src="img/live_img/19.png"/></div>
                                    <div className="div_li"><img src="img/live_img/19.png"/></div>
                                    <div className="div_li"><img src="img/live_img/19.png"/></div>
                                    <div className="div_li"><img src="img/live_img/19.png"/></div>
                                    <div className="div_li"><img src="img/live_img/19.png"/></div>
                                    <div className="div_li"><img src="img/live_img/19.png"/></div>
                                    <div className="div_li"><img src="img/live_img/19.png"/></div>
                                    <div className="div_li"><img src="img/live_img/19.png"/></div>
                                    <div className="div_li"><img src="img/live_img/icon_more.png"/></div>
                                </div>
                            </div>
                            */}
              <div className="chatting_input">
                <p>채팅에 참여하시려면 로그인 해주세요.</p>
              </div>
            </Fragment>
          ) : (
            <div
              className={
                intReturn === 0
                  ? chatOn
                    ? "chatting_position img_bg_no"
                    : "chatting_position"
                  : "chatting_position"
              }
            >
              {connect === "Y" ? (
                <Fragment>
                  <div className="chatting_position">
                    <div className="chatting_group"></div>
                  </div>
                  {/*
                                    <div className="chatting_icon">
                                        <div className="div_ul">
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/icon_more.png"/></div>
                                        </div>
                                    </div>
                                    */}
                  <div className="chatting_input">
                    <p>
                      채팅서버에 중복접속이 되었습니다. 새로고침 후 다시
                      시도해주세요.
                    </p>
                  </div>
                </Fragment>
              ) : chatOn ? (
                !user ? (
                  <LoginForm
                    socket={socket}
                    setUser={this.setUser}
                    logout={this.logout}
                    getConnect={this._getConnect}
                  />
                ) : (
                  <ChatContainer
                    socket={socket}
                    user={user}
                    logout={this.logout}
                  />
                )
              ) : (
                <Fragment>
                  <div className="chatting_position">
                    <div className="chatting_group"></div>
                  </div>
                  {/*
                                    <div className="chatting_icon">
                                        <div className="div_ul">
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/19.png"/></div>
                                            <div className="div_li"><img src="img/live_img/icon_more.png"/></div>
                                        </div>
                                    </div>
                                    */}
                  <div className="chatting_input">
                    <p>채팅에 참가 및 나가기는 상단의 ON/OFF를 클릭해주세요.</p>
                  </div>
                </Fragment>
              )}
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Layout));
